<template>
  <p>{{ $t('errorMsg') }}</p>
</template>

<script>
export default {
  name: "error-page",
}
</script>

<!--
<i18n>
{
    "en": {
        "errorMsg" : "test en lang"
    }
}
</i18n>
-->
